const TOKEN_KEY = 'token';
const USER_INFO_KEY = 'userInfo';

const isLogin = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};

const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

const getUserInfo = () => {
  const userInfo = localStorage.getItem(USER_INFO_KEY);
  return userInfo ? JSON.parse(userInfo) : null;
};

const setUserInfo = (userInfo) => {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
};

const clearUserInfo = () => {
  localStorage.removeItem(USER_INFO_KEY);
};

export { 
  isLogin, 
  getToken, 
  setToken, 
  clearToken,
  getUserInfo,
  setUserInfo,
  clearUserInfo
};